import { AnimatePresence, motion } from 'framer-motion';
import PropTypes from 'prop-types';

import { BUTTON_BASE_CLASSES } from '../../../../components/Button/ButtonTheme';
import { clsm } from '../../../../utils';
import { createAnimationProps } from '../../../../helpers/animationPropsHelper';
import { DownArrow } from '../../../../assets/icons';

const StickScrollButton = ({ isSticky = true, scrollToBottom }) => (
  <AnimatePresence>
    {!isSticky && (
      <motion.div
        {...createAnimationProps({
          animations: ['fadeIn-full', 'scale'],
          customVariants: {
            hidden: { y: '25%' },
            visible: { y: 0 }
          }
        })}
        className={clsm([
          'absolute',
          'bottom-2',
          'flex',
          'justify-center',
          'pb-3',
          'z-30',
          'w-full',
          'pointer-events-none'
        ])}
      >
        <button
          aria-label="Scroll to bottom"
          className={clsm(
            BUTTON_BASE_CLASSES,
            '[&>svg]:!fill-white',
            '[&>svg]:h-5',
            '[&>svg]:w-5',
            'bg-lightMode-gray-medium',
            'dark:[&>svg]:!fill-black',
            'dark:bg-darkMode-gray-light',
            'dark:focus:bg-darkMode-gray-light',
            'dark:hover:bg-darkMode-gray-light-hover',
            'dark:text-black',
            'focus-visible:outline-none',
            'focus-visible:outline-offset-0',
            'h-10',
            'w-10',
            'min-w-0',
            'p-0',
            'rounded-full',
            'flex',
            'items-center',
            'justify-center',
            'hover:bg-lightMode-gray-medium-hover',
            'text-white',
            'shadow-[0_1px_3px_0_rgba(255,255,255,0.4)]',
            'pointer-events-auto'
          )}
          type="button"
          onClick={scrollToBottom}
        >
          <DownArrow />
        </button>
      </motion.div>
    )}
  </AnimatePresence>
);

StickScrollButton.propTypes = {
  isSticky: PropTypes.bool,
  scrollToBottom: PropTypes.func.isRequired
};

export default StickScrollButton;
